/*
 * Per-deployment settings, fetched at start from /config.json so one build
 * serves any environment (lab edge, production). Example in
 * public/config.example.json.
 */
export interface SiteConfig {
  /** mt-prov-sf base URL, e.g. https://png.moctel.com/sf; empty: no MocTel activation */
  prov_url: string;
  /** the SIP edge, e.g. wss://edge.moctel.com:8443 */
  wss_url: string;
  /** STUN/TURN before provisioning gives short-lived TURN credentials */
  ice_servers: RTCIceServer[];
  /** echo service dialed by the call-quality test */
  echo_test: string;
  /** offer manual SIP setup (lab, support) */
  manual_setup: boolean;
  /** origins allowed to frame the app and drive it (docs/embedding.md),
   * e.g. ["https://dispatch.example.com"]; the same list as Caddy's
   * frame-ancestors */
  embed_origins: string[];
}

const DEFAULTS: SiteConfig = {
  prov_url: "",
  wss_url: "",
  ice_servers: [],
  echo_test: "mtstd_echotest",
  manual_setup: false,
  embed_origins: [],
};

export async function loadSiteConfig(): Promise<SiteConfig> {
  try {
    const r = await fetch("/config.json", { cache: "no-store" });
    if (r.ok) return { ...DEFAULTS, ...(await r.json()) };
  } catch {
    /* offline: the service worker serves the cached copy, else defaults */
  }
  return DEFAULTS;
}
